import { mapGetters } from 'vuex';
import moment from 'moment';

const formatFiscalYear = {
  computed: {
    ...mapGetters('syndicates', [
      'syndicate',
    ]),
  },
  methods: {
    formatFiscalYear(year) {
      let previousYear = '';
      if (this.syndicate && Number(this.syndicate.creationDate.split('-')[1]) > 1) {
        previousYear = `${moment(year).subtract(1, 'year').format('YYYY')}-`;
      }
      return `${previousYear}${moment(year).format('YYYY')}`;
    },
  },
};


export default formatFiscalYear;



// WEBPACK FOOTER //
// ./src/mixins/formatFiscalYear.js